import { getColor } from '../utils/constants'

export const planeSymbolDefault = () => {
  return {
    path: `M21.5 2.5c1 1 0 3.5-1.5 5l-2.516 2.516 2.5 10.875c0.047 0.187-0.031 0.391-0.187 0.516l-2 1.5c-0.078 0.063-0.187 0.094-0.297 0.094-0.031 0-0.063 0-0.109-0.016-0.141-0.031-0.266-0.109-0.328-0.25l-4.359-7.938-4.047 4.047 0.828 3.031c0.047 0.172 0 0.344-0.125 0.484l-1.5 1.5c-0.094 0.094-0.234 0.141-0.359 0.141h-0.031c-0.156-0.016-0.281-0.078-0.375-0.203l-2.953-3.938-3.938-2.953c-0.125-0.078-0.187-0.219-0.203-0.359s0.047-0.281 0.141-0.391l1.5-1.516c0.094-0.094 0.234-0.141 0.359-0.141 0.047 0 0.094 0 0.125 0.016l3.031 0.828 4.047-4.047-7.938-4.359c-0.141-0.078-0.234-0.219-0.266-0.375-0.016-0.141 0.031-0.313 0.141-0.422l2-2c0.125-0.109 0.313-0.172 0.469-0.125l10.391 2.484 2.5-2.5c1.5-1.5 4-2.5 5-1.5z`,
    anchor: new google.maps.Point(14, 10),
    scale: 1,
    strokeColor: getColor('PLANE_STROKE'),
    fillColor: getColor('PLANE_FILL'),
    strokeWeight: 1,
    fillOpacity: 1,
    rotation: '135'
  }
}

export const planeSymbolHover = () => {
  return {
    path: `M21.5 2.5c1 1 0 3.5-1.5 5l-2.516 2.516 2.5 10.875c0.047 0.187-0.031 0.391-0.187 0.516l-2 1.5c-0.078 0.063-0.187 0.094-0.297 0.094-0.031 0-0.063 0-0.109-0.016-0.141-0.031-0.266-0.109-0.328-0.25l-4.359-7.938-4.047 4.047 0.828 3.031c0.047 0.172 0 0.344-0.125 0.484l-1.5 1.5c-0.094 0.094-0.234 0.141-0.359 0.141h-0.031c-0.156-0.016-0.281-0.078-0.375-0.203l-2.953-3.938-3.938-2.953c-0.125-0.078-0.187-0.219-0.203-0.359s0.047-0.281 0.141-0.391l1.5-1.516c0.094-0.094 0.234-0.141 0.359-0.141 0.047 0 0.094 0 0.125 0.016l3.031 0.828 4.047-4.047-7.938-4.359c-0.141-0.078-0.234-0.219-0.266-0.375-0.016-0.141 0.031-0.313 0.141-0.422l2-2c0.125-0.109 0.313-0.172 0.469-0.125l10.391 2.484 2.5-2.5c1.5-1.5 4-2.5 5-1.5z`,
    anchor: new google.maps.Point(14, 10),
    scale: 1,
    strokeColor: getColor('PLANE_STROKE_HOVER'),
    fillColor: getColor('PLANE_FILL_HOVER'),
    strokeWeight: 1,
    fillOpacity: 1,
    rotation: '135'
  }
}



// WEBPACK FOOTER //
// ./app/polylines/symbols.js